export default __webpack_public_path__ + "static/media/step3bDarkMode.e9bc3624.svg";